export default "__VITE_ASSET__3762299f__"